var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5H7.875C7.66406 5 7.5 5.1875 7.5 5.375V6.5C7.5 8.25781 5.97656 9.66406 4.19531 9.5C2.625 9.33594 1.5 7.95312 1.5 6.38281V5.375C1.5 5.1875 1.3125 5 1.125 5H0.75C0.539062 5 0.375 5.1875 0.375 5.375V6.33594C0.375 8.42188 1.85156 10.2969 3.9375 10.5781V11.375H2.625C2.41406 11.375 2.25 11.5625 2.25 11.75V12.125C2.25 12.3359 2.41406 12.5 2.625 12.5H6.375C6.5625 12.5 6.75 12.3359 6.75 12.125V11.75C6.75 11.5625 6.5625 11.375 6.375 11.375H5.0625V10.6016C7.05469 10.3203 8.625 8.58594 8.625 6.5V5.375C8.625 5.1875 8.4375 5 8.25 5ZM4.5 8.75C5.74219 8.75 6.75 7.76562 6.75 6.5V2.75C6.75 1.50781 5.74219 0.5 4.5 0.5C3.23438 0.5 2.25 1.50781 2.25 2.75V6.5C2.25 7.76562 3.23438 8.75 4.5 8.75ZM3.375 2.75C3.375 2.14062 3.86719 1.625 4.5 1.625C5.10938 1.625 5.625 2.14062 5.625 2.75V6.5C5.625 7.13281 5.10938 7.625 4.5 7.625C3.86719 7.625 3.375 7.13281 3.375 6.5V2.75Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.cb4f17944f25164db4b05b5d8a6ca97f.svg";
export { ForwardRef as ReactComponent };